// extracted by mini-css-extract-plugin
export default {"skeleton-column":"e9f188"};